import { render } from "./ComplaintsList.vue?vue&type=template&id=d11fe790"
import script from "./ComplaintsList.vue?vue&type=script&lang=js"
export * from "./ComplaintsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__